module.exports = __webpack_public_path__ + "static/what-ktg-is-banner-c3609fbc5c0bbe21b903f317f867466e.svg";